<div class="shop-add component-container component-page-container action-button-wrapper"
    fxLayout="column"
    fxLayoutGap="2%"
>
    <div class="sh-page-wrapper bottom-action-mg">
        <div fxFlex="50%">
            <custom-panel header="Opis placówki" [areButtons]="false" class="flex flex-grow">
                <div panel-body>
                    <form [formGroup]="creatingForm" (ngSubmit)="onSubmit()" fxLayout="column">
                        <mat-form-field>
                            <input matInput placeholder="Nazwa placówki" formControlName="Name" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Sieć" formControlName="Chain" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput type="number" placeholder="Numer placówki" formControlName="Number" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Kod placówki" formControlName="Code">
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Kraj" formControlName="Country" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Województwo" formControlName="Region0" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Region" formControlName="Region1">
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Miasto" (blur)="getShopLocation()" formControlName="City" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Ulica"  (blur)="getShopLocation()" formControlName="Street" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Numer budynku" (blur)="getShopLocation()" formControlName="StreetNumber" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Kod pocztowy" formControlName="ZipCode" required>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput type="number" placeholder="Powierzchnia placówki" formControlName="Surface" >
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput placeholder="Rodzaj asortymentu" formControlName="StockType">
                        </mat-form-field>

                        <mat-form-field>
                            <mat-select formControlName="ClusterId" placeholder="Klaster">
                                <mat-option *ngFor="let cluster of clusters" [value]="cluster.id">
                                    {{cluster.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-checkbox
                            formControlName="FridgeBeer"
                        >
                            Czy są lodówki z piwem?
                        </mat-checkbox>

                        <mat-checkbox
                            formControlName="FridgeIceCream"
                        >
                            Czy są lodówki z lodami?
                        </mat-checkbox>

                        <button #submitButton type="submit" style="display: none;"></button>
                    </form>
                </div>
            </custom-panel>
        </div>

        <div fxFlex="50%">
            <leaflet-maps
                [options]="shopLocation"
                [shopsAddress]="compShopsLocation"
            >
            </leaflet-maps>
        </div>
    </div>

    <div fxLayout="row" fxLayout.md="column" fxLayoutGap="1%" class="inner-nav-bar">
        <div  fxFlex="50%">
            <custom-panel header="Lista placówek konkurencji" [areButtons]="false" class="flex flex-grow">
                <div panel-body>
<!--                    <select-table [dataService]="compShopService" [columnSelectData]="columnsData"-->
<!--                        [selectedData]="selectedItems" (addRow)="addNewRow($event)" [sortByField]="sortBy"-->
<!--                        [(customPageSize)]="pageSize"-->
<!--                    ></select-table>-->

                    <pr-select-table
                        [dataService]="compShopService"
                        [selectedData]="selectedItems"
                        (selectedRows)="addNewRow($event)"
                        [columnsData]="columnsData"
                        [dataServiceMethod]="'fetchSelectData'"
                        [title]="''"
                        [(customPageSize)]="pageSize"
                        [sortBy]="sortBy"
                        [tableId]="tableId + 'Select'"
                    ></pr-select-table>
                </div>
            </custom-panel>
        </div>

        <div  fxFlex="50%">
            <custom-panel header="Wybrane placówki konkurencji" [areButtons]="false" class="flex flex-grow">
                <div panel-body>
<!--                    <unselect-table [columnSelectData]="columnsData"-->
<!--                        [selectedData]="selectedItems" (removeProduct)="removeSelectedRow($event)"-->
<!--                        [(customPageSize)]="pageSize"-->
<!--                    ></unselect-table>-->

                    <pr-unselect-table
                        [columnsData]="columnsData"
                        [title]="''"
                        [tableData]="selectedItems"
                        (removeProduct)="removeSelectedRow($event)"
                        [(customPageSize)]="pageSize"
                        [tableId]="tableId + 'Unselect'"
                    ></pr-unselect-table>
                </div>
            </custom-panel>
        </div>
    </div>
</div>


<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row"
        fxLayoutGap="1%" fxLayoutAlign="flex-end center"
    >
        <button-spinner class="ml-xxs" [inProgress]="isSaving" diameter="20">
        </button-spinner>
        <button type="button" class="upper action-button butt-back action-button-icon"
            (click)="navigationBack()"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="submitButton.click()"
            [disabled]="isSaving" class="upper action-button butt-primary action-button-icon">
            <p class="upper">zapisz</p>
            <mat-icon class="action-icon">save_alt</mat-icon>
        </button>
    </div>
</div>
